module.exports = __webpack_public_path__ + "static/media/meteringicon01@3x.1d890cba.png";